import queryString from 'query-string';

const queryStringParser = {
  stringify(object, options) {
    return queryString.stringify(object, options);
  },

  parse(string, options) {
    return queryString.parse(string, options);
  },

  extract(string) {
    return queryString.extract(string);
  },

  parseAndMakeKeysLowerCase(string, options) {
    const parsed = queryStringParser.parse(string, options);
    return Object.keys(parsed).reduce((result, key) => ({
      ...result,
      [key.toLowerCase()]: parsed[key],
    }), {});
  },
};

export default queryStringParser;
